import { render } from "./MyDeity.vue?vue&type=template&id=0dad9556&scoped=true"
import script from "./MyDeity.vue?vue&type=script&lang=js"
export * from "./MyDeity.vue?vue&type=script&lang=js"

import "./MyDeity.vue?vue&type=style&index=0&id=0dad9556&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dad9556"]])

export default __exports__